export default __webpack_public_path__ + "static/kosakowo_logo_CMYK (1)-18add1845ad1004b379b667c96031d15.png";